<template>
  <cdr-modal
    v-if="modalObject"
    :label="modalObject.label"
    :aria-described-by="modalObject.ariaDescribedBy"
    :opened="modalObject.modalIsOpen"
    @closed="closeModal"
  >
    <template #title>
      {{ modalObject.label }}
    </template>
    <component :is="modalObject.modalContent" v-bind="dynamicProps" v-on="dynamicOn" />
  </cdr-modal>
</template>

<script>
import { CdrModal } from '@rei/cedar';
import { mapActions, mapState } from 'pinia';
import ErrorModal from './ErrorModal.vue';
import TermsAndConditionsModal from './TermsAndConditionsModal.vue';
import AddToCartModal from './AddToCartModal.vue';
import { useWishlistStore } from '../../stores';

export default {
  name: 'ModalContainer',
  components: {
    ErrorModal,
    TermsAndConditionsModal,
    AddToCartModal,
    CdrModal,
  },
  computed: {
    ...mapState(useWishlistStore, ['addToCartState']),
    modalObject() {
      if (this.addToCartState.modal) {
        return {
          modalIsOpen: !!this.addToCartState.modalIsOpen,
          ...this.addToCartState.modal,
        };
      }
      return null;
    },
    dynamicProps() {
      return this.modalObject.modalProps;
    },
    dynamicOn() {
      return {
        modalClose: () => this.closeModal(),
        acceptTerms: () => this.handleAcceptTerms(),
        declineTerms: () => this.closeModal(),
      };
    },
  },
  methods: {
    ...mapActions(useWishlistStore, ['closeModal', 'handleAcceptTerms']),
  },
};
</script>
